export enum ErrorCodes {
"label.gb.about"="About",
"label.gb.address_contact"="Address and Contact",
"label.gb.email"="Email",
"label.gb.text_msg_id"="Text message",
"label.gb.serial_number"="Serial No.",
"label.gb.dev_name"="Device name",
"label.gb.implant_date"="Implant Date",
"label.gb.firstname"="First name",
"label.gb.middlename"="Middle name",
"label.gb.lastname"="Last name",
"label.gb.gender"="Gender",
"label.gb.date_of_birth"="Date of birth",
"label.gb.pat_prefers"="Patient language",
"label.gb.clinic_loc"="Clinic location",
"label.gb.cliniclocation"="Clinic Location",
"label.gb.pat_record_no"="Patient ID",
"label.gb.address"="Address",
"label.gb.home_phone"="Phone",
"label.gb.middle"="Middle",
"label.gb.city"="City",
"label.gb.state_province"="State/Prov.",
"label.gb.country"="Country",
"label.gb.zip_post_code"="Zip/Postal code",
"label.gb.email_addr"="Email",
"label.gb.am"="AM",
"label.gb.pm"="PM",
"label.gb.other_phone"="Other phone",
"label.gb.primary_phone"="Primary/Mobile phone",
"label.gb.primary_phone_mobile"="Primary/Mobile phone",
"label.filter.clinic_name"="Clinic Name",
"label.gb.basic_implanting"="Implanting",
"label.gb.doc_perform_implant"="Implanting Physician",
"label.gb.doc_refers_patients"="Treating Physician",
"label.filter.specific_PRN"="Patient ID",
"label.filter.device_type"="Device type",
"label.gb.device"="Device",
"label.gb.oncall_physician"="On-call Physician",
"label.gb.mmddyyyy"="MM-DD-YYYY",
"label.gb.ddmmyyyy"="DD-MM-YYYY",
"label.gb.yyyymmdd"="YYYY-MM-DD",
"label.gb.contact_info"="Contact Information",
"label.gb.physician_name"="Physician Name",
"label.gb.between"="Between",
"label.gb.and"="and",
"label.gb.phone_country_code"="Country Code",
"label.gb.phone_area_code"="Area/City Code",
"label.gb.phone_number"="Phone Number",
"label.gb.language"="Language",
"label.gb.phone"="Phone",
"label.gb.race"="Race",
"label.gb.textmessage"="text message",
"label.gb.address1"="Address 1",
"label.gb.address2"="Address 2",
"label.gb.address3"="Address 3",
"label.gb.cell_ph_txt_msg"="Cell Phone / Text message",
"label.gb.emergency_contact"="Emergency Contact",
"label.rx.primary_physician"="Primary Physician",
"label.gb.birth_date"="Date of Birth",
"label.gb.DOB"="DOB",
 "label.gb.text_message"="Text Message",
"label.gb.or"="or",
"label.gb.implanting"="Implanting",
"label.gb.phy_user_roles"="Physician User Roles",
 "msg.cs813.text"="The time range entered is invalid. The {1} can't be earlier than {0}. Please re-enter the {0}, {1} range again.",
 "msg.cs816.text"="Please correct the following fields marked in red below.",
 "msg.cs818.text"=`The following fields are required:`,
 "msg.pa854a.text"="The Patient ID you provided is already assigned to another patient.Please enter another Patient ID.",
"label.gb.call_phonenumber"="Call phone number",
"msg.outboundfaxemailmsg.phone"="Phone",
"label.gb.none"="None",
"msg.cs816.text_appendix"="Date Field FOrmat is wrong",
"label.gb.notify_patient"="Notify",
"msg.pa825.text"="The device model and serial number combination does not exist in our records.Please provide a different model and serial number combination.",
"msg.pa874.text"="The device model and serial number combination belongs to another patient.Please provide a different model and serial number combination.",
"msg.cp838.text"=" The specified transmitter is already in use by another clinic or patient. Please check the serial number. If you require further assistance, please contact Abbott Technical Support. ",
}